import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["statusField", "dateField", "timeField"];
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSelectedAndTodayDate, userLocalTimezone } from 'utils/timezone';
import getBasicDate from 'utils/dates/getBasicDate';
import { DEFAULT_TIME } from 'utils/times/defaultTime';
import RadioButtonOption from 'components/RadioButtonOption';
import FormField from 'components/FormField';
import Stack from 'components/Stack';
import CompletionDateTimeCard from './CompletionDateTimeCard';
function checkIsValid(field) {
  return field.value !== null;
}
function CompletionStatusField(_ref) {
  var statusField = _ref.statusField,
    dateField = _ref.dateField,
    timeField = _ref.timeField,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasCompletionDateTimeCard = statusField.value === 'completed' && checkIsValid(dateField) && checkIsValid(timeField);
  var timezone = userLocalTimezone;
  var _getSelectedAndTodayD = getSelectedAndTodayDate(dateField.value, timezone),
    selectedDate = _getSelectedAndTodayD.selectedDate,
    zonedTodayDate = _getSelectedAndTodayD.zonedTodayDate;
  var modes = [{
    label: 'actions_do_not_change',
    value: 'unchanged',
    onChange: function onChange() {
      return statusField.set('unchanged');
    }
  }, {
    label: 'actions_set_to_not_started',
    value: 'notstarted',
    onChange: function onChange() {
      statusField.set('notstarted');
      dateField.set(null);
      timeField.set(null);
    }
  }, {
    label: 'actions_set_to_completed',
    value: 'completed',
    onChange: function onChange() {
      var date = getBasicDate(zonedTodayDate);
      statusField.set('completed');
      dateField.set(date);
      timeField.set(DEFAULT_TIME);
    }
  }];
  var statusOptions = modes.map(function (mode) {
    return /*#__PURE__*/React.createElement(RadioButtonOption, {
      key: mode.value,
      id: mode.value,
      label: t(mode.label),
      checked: statusField.value === mode.value,
      value: mode.value,
      onChange: mode.onChange
    });
  });
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "fieldset",
    label: "".concat(t('property_new_completion_status'), " *")
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, statusOptions, hasCompletionDateTimeCard && /*#__PURE__*/React.createElement(CompletionDateTimeCard, {
    dateField: dateField,
    timeField: timeField,
    selectedDate: selectedDate,
    timezone: timezone
  })));
}
export default CompletionStatusField;